import { toast } from 'react-toastify';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { selectedCompanyStorage } from '../../storage/company/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { useLocale } from '../use-locale.hook';

export const useInvitation = () => {
  const companyId = selectedCompanyStorage(({ companyId }) => companyId);
  const { messagesLocale } = useLocale();
  const { invalidateQuery: invalidateTeam } = useInvalidateQueries(QueryKey.GET_TEAM);

  const { mutate: cancelInvitation, isPending: isPendingCancelInvite } = useIdempotentAppMutation(
    [QueryKey.CANCEL_STAKEHOLDER_INVITATION],
    {
      mutationFn: (
        { stakeholderId, subEmail }: { stakeholderId: string; subEmail?: string },
        { headers },
      ) =>
        ApiService.post(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', stakeholderId, 'cancel-invitation'],
          },
          {
            queryParams: {
              subEmail,
            },
            headers,
          },
        ),

      onSuccess: () => {
        toast.success(messagesLocale['INVITATION_SUCCESSFULLY_CANCELED']);
        invalidateTeam();
      },
    },
  );

  const { mutate: invite, isPending: isPendingInvite } = useIdempotentAppMutation(
    [QueryKey.INVITE_STAKEHOLDER],
    {
      mutationFn: (
        { stakeholderId, subEmail }: { stakeholderId: string; subEmail?: string },
        { headers },
      ) =>
        ApiService.post(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', stakeholderId, 'invite'],
          },
          {
            queryParams: {
              subEmail,
            },
            headers,
          },
        ),

      onSuccess: () => {
        toast.success(messagesLocale['INVITATION_SUCCESSFULLY_SENT']);
        invalidateTeam();
      },
    },
  );

  return { cancelInvitation, isPendingInvite, invite, isPendingCancelInvite };
};
